import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import TargetingAreasList from "./targeting-areas-list";

const propTypes = {
  destinationURL: PropTypes.string,
  venue: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string
  }),
  targetingAreas: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      radius: PropTypes.number
    })
  ).isRequired,
  uniqueContacts: PropTypes.number
};

const CampaignConfiguration = ({
  destinationURL = null,
  venue = null,
  targetingAreas,
  uniqueContacts = null
}) => {
  return (
    (destinationURL || venue || uniqueContacts || targetingAreas.length > 0) && (
      <div>
        <h6 className="text-uppercase font-weight-semibold font-size-small mb-3">
          Campaign Configuration
        </h6>
        <div className="campaign-card-section p-2 mb-3">
          <Row>
            {venue && (
              <Col xs="12" className="my-2">
                <div className="d-flex align-items-start">
                  <span className="icon-badge d-none d-md-inline-flex">
                    <i className="fa fa-building icon-badge__icon" aria-hidden="true" />
                  </span>
                  <div className="w-100">
                    <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                      Venue
                    </div>
                    <div className="font-weight-bold text-default">{venue.name}</div>
                    {venue.address && (
                      <div className="font-size-small text-muted">{venue.address}</div>
                    )}
                  </div>
                </div>
              </Col>
            )}
            {destinationURL && (
              <Col xs="12" className="my-2">
                <div className="d-flex align-items-start">
                  <span className="icon-badge d-none d-md-inline-flex">
                    <i className="fa fa-globe" aria-hidden="true" />
                  </span>
                  <div className="w-100" style={{ minWidth: 0 }}>
                    <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                      Destination URL
                    </div>
                    <a
                      className="font-weight-bold text-decoration-none text-default d-flex align-items-center"
                      href={destinationURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="text-truncate" style={{ minWidth: 0 }}>
                        {destinationURL}
                      </span>
                      <i className="fa fa-external-link ml-2 flex-shrink-0" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </Col>
            )}
            {uniqueContacts && (
              <Col xs="12" md="6" className="my-2">
                <div className="d-flex align-items-start">
                  <span className="icon-badge d-none d-md-inline-flex">
                    <i className="fa fa-user" aria-hidden="true" />
                  </span>
                  <div className="w-100">
                    <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                      Targeting Audience
                    </div>
                    <div className="font-weight-bold text-decoration-none text-default">
                      {uniqueContacts} unique data points
                    </div>
                  </div>
                </div>
              </Col>
            )}
            {targetingAreas.length > 0 && (
              <Col xs="12" className="my-2">
                <div className="d-flex align-items-start">
                  <span className="icon-badge d-none d-md-inline-flex">
                    <i className="fa fa-map-marker icon-badge__icon" aria-hidden="true" />
                  </span>
                  <div className="w-100">
                    <div className="text-uppercase font-size-small font-weight-semibold text-muted mb-1">
                      Targeting
                    </div>
                    <TargetingAreasList targetingAreas={targetingAreas} />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    )
  );
};

CampaignConfiguration.propTypes = propTypes;

export default CampaignConfiguration;
